// extracted by mini-css-extract-plugin
export default {"panel":"tradeVolume_panel__anzk+","panelHeader":"tradeVolume_panelHeader__Mqjmn","panelContent":"tradeVolume_panelContent__9LMyi"};